import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import axios from "axios";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { CartProvider } from "@/contexts/CartContext";

// Components
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MobileMenu from "@/components/MobileMenu";
import CartDrawer from "@/components/CartDrawer";
import MailingListPopup from "@/components/MailingListPopup";

// Pages
import Home from "@/pages/Home";
import Collection from "@/pages/Collection";
import ProductDetail from "@/pages/ProductDetail";
import Memberships from "@/pages/Memberships";
import MembershipSuccess from "@/pages/MembershipSuccess";
import Bespoke from "@/pages/Bespoke";
import Events from "@/pages/Events";
import FloralBar from "@/pages/FloralBar";
import Atelier from "@/pages/Atelier";
import Archive from "@/pages/Archive";
import Journal from "@/pages/Journal";
import Inquiries from "@/pages/Inquiries";
import FAQ from "@/pages/FAQ";
import Admin from "@/pages/Admin";
import Auth from "@/pages/Auth";
import Account from "@/pages/Account";
import Manifesto from "@/pages/Manifesto";
import CheckoutSuccess from "@/pages/CheckoutSuccess";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const seedDatabase = async () => {
      try { await axios.post(`${API}/seed`); } catch (e) { console.log("Database seed check complete"); }
    };
    seedDatabase();
  }, []);

  return (
    <div className="App min-h-screen bg-[#0c0c0c]">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <ScrollToTop />
            <Navbar onMenuClick={() => setMobileMenuOpen(true)} />
            <MobileMenu isOpen={mobileMenuOpen} onClose={() => setMobileMenuOpen(false)} />
            <CartDrawer />
            <MailingListPopup />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/collection" element={<Collection />} />
                <Route path="/collection/:id" element={<ProductDetail />} />
                <Route path="/memberships" element={<Memberships />} />
                <Route path="/memberships/success" element={<MembershipSuccess />} />
                <Route path="/bespoke" element={<Bespoke />} />
                <Route path="/events" element={<Events />} />
                <Route path="/floral-bar" element={<FloralBar />} />
                <Route path="/atelier" element={<Atelier />} />
                <Route path="/archive" element={<Archive />} />
                <Route path="/journal" element={<Journal />} />
                <Route path="/inquiries" element={<Inquiries />} />
                <Route path="/faq" element={<FAQ />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/auth" element={<Auth />} />
                <Route path="/account" element={<Account />} />
                <Route path="/manifesto" element={<Manifesto />} />
                <Route path="/checkout/success" element={<CheckoutSuccess />} />
              </Routes>
            </main>
            <Footer />
            <Toaster position="bottom-right" />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
